interface PostLinkProps {
  postUrl: string | null;
  className?: string;
}

export function PostLink({ postUrl, className = '' }: PostLinkProps) {
  if (postUrl == null) return null;

  return (
    <a
      href={postUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="View original post on Instagram"
      className={`inline-flex items-center text-sm text-blue-600 hover:text-blue-800 hover:underline ${className}`}
    >
      View original post ↗
    </a>
  );
}
